import { useQuery, keepPreviousData } from "@tanstack/react-query";
import {
  getFactoryCreditTransactions,
  CreditTransactionListQuery,
  CreditTransactionListResponse,
} from "services/factoryCreditApi";

export const CREDIT_TRANSACTIONS_QUERY_KEY = "factoryCreditTransactions";

export const useFactoryCreditTransactions = (
  params: CreditTransactionListQuery,
  options?: { enabled?: boolean }
) =>
  useQuery<CreditTransactionListResponse, Error>({
    queryKey: [CREDIT_TRANSACTIONS_QUERY_KEY, params],
    queryFn: () => getFactoryCreditTransactions(params),
    enabled: options?.enabled ?? true,
    placeholderData: keepPreviousData,
    refetchOnMount: "always",
  });
